
























import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Mixins
import Errors from '@/mixins/Errors'
import Form from '@/mixins/Form'

// Components
import InfoBox from '@/components/common/InfoBox.vue'

@Component({
  components: {
    InfoBox
  }
})
export default class AddAffiliationUserForm extends Mixins(Errors, Form) {
  email: string = null
  userNotFound: boolean = false

  @Getter('token') token
  @Prop() code
  @Prop() desc

  cancel() {
    this.$emit('close')
  }

  async add() {
    try {
      this.userNotFound = false
      this.formLoading = true
      const res = await this.$api.affiliation.addAffiliationUser(this.token, this.code, this.email)
      console.log(res)
      this.$emit('add')
      this.$emit('close')
    } catch (error) {
      this.userNotFound = true
      this.email = null
    } finally {
      this.formLoading = false
    }
  }
}
